import { useState, useEffect, useContext } from "react";
import axios from "axios";
// import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { serverBaseAddress } from "../Pages/APIPage";
import { openJcPreview, downloadJcWord } from "./JCDocument";
import { UserContext } from "../Pages/UserContext";
import { Button } from "@mui/material";

const JobCardComponent = ({ id }) => {
  // const { id } = useParams();
  const { loggedInUserDepartment } = useContext(UserContext);
  const isPdfEnabled =
    loggedInUserDepartment === "Administration" ||
    loggedInUserDepartment === "Accounts";

  const [jobCard, setJobCard] = useState({
    jcNumber: "",
    srfNumber: "",
    jcOpenDate: "",
    itemReceivedDate: "",
    jcCloseDate: "",
    companyName: "",
    typeOfRequest: "",
    testCategory: "",
    testDiscipline: "",
    reportType: "",
    sampleCondition: "",
    projectName: "",
    customerName: "",
    companyAddress: "",
    customerEmail: "",
    customerPhone: "",
    testWitnessedBy: "",
    jcCreatedBy: "",
    testInstructions: "",

    relReportStatus: "",
    jcCategory: "",

    observations: "",
    jcStatus: "",

    eutDetails: [],
    tests: [],
    testDetails: [],

    reliabiltyTasks: [],
  });

  useEffect(() => {
    axios
      .get(`${serverBaseAddress}/api/jobcard/${id}`)
      .then((response) => {
        const {
          jobcard,
          eut_details,
          tests,
          tests_details,
          reliability_tasks_details,
        } = response.data;

        //Parse and seggregate JC Tests table:
        const parsedJcTests = tests.map((test, index) => {
          return {
            ...test,
            slNoCounter: index + 1,
          };
        });

        // Parse and segregate date and time for tests_details
        const parsedTestsDetails = tests_details.map((test, index) => {
          const startDate = new Date(test.startDate);
          const endDate = new Date(test.endDate);

          const startDateObj = {
            date: dayjs(startDate).isValid()
              ? dayjs(startDate).format("DD-MM-YYYY")
              : "",
            time: startDate.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          };

          const endDateObj = {
            date: dayjs(endDate).isValid()
              ? dayjs(endDate).format("DD-MM-YYYY")
              : "",
            time: endDate.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          };

          return {
            ...test,
            startDate: startDateObj,
            endDate: endDateObj,
            slNoCounter: index + 1,
          };
        });

        const parsedEUTDetails = eut_details.map((detail, index) => {
          return {
            ...detail,
            slNoCounter: index + 1,
          };
        });

        const parsedRelTasksDetails = reliability_tasks_details.map(
          (detail, index) => {
            const taskStartDate = dayjs(detail.task_start_date).format(
              "DD-MM-YYYY",
            );
            const taskEndDate = dayjs(detail.task_end_date).format(
              "DD-MM-YYYY",
            );
            const taskCompletionDate = dayjs(detail.task_completed_date).format(
              "DD-MM-YYYY",
            );

            return {
              ...detail,
              taskStartDate,
              taskEndDate,
              taskCompletionDate,
              slNoCounter: index + 1,
            };
          },
        );

        // console.log(jobcard)

        setJobCard({
          jcNumber: jobcard.jc_number,
          srfNumber: jobcard.srf_number,
          srfDate: dayjs(jobcard.srf_date).isValid()
            ? dayjs(jobcard.srf_date).format("DD-MM-YYYY")
            : "",
          jcOpenDate: dayjs(jobcard.jc_open_date).isValid()
            ? dayjs(jobcard.jc_open_date).format("DD-MM-YYYY")
            : "",
          itemReceivedDate: dayjs(jobcard.item_received_date).isValid()
            ? dayjs(jobcard.item_received_date).format("DD-MM-YYYY")
            : "",
          jcCloseDate: dayjs(jobcard.jc_closed_date).isValid()
            ? dayjs(jobcard.jc_closed_date).format("DD-MM-YYYY")
            : "",
          companyName: jobcard.company_name,
          companyAddress: jobcard.company_address,
          typeOfRequest: jobcard.type_of_request,
          testCategory: jobcard.test_category,
          testDiscipline: jobcard.test_discipline,
          reportType: jobcard.report_type,
          sampleCondition: jobcard.sample_condition,
          projectName: jobcard.project_name,
          customerName: jobcard.customer_name,
          customerEmail: jobcard.customer_email,
          customerPhone: jobcard.customer_number,
          testWitnessedBy: jobcard.test_witnessed_by,
          jcCreatedBy: jobcard.jc_created_by,

          relReportStatus: jobcard.reliability_report_status,
          jcCategory: jobcard.jc_category,

          observations: jobcard.observations,
          testInstructions: jobcard.test_instructions,
          jcStatus: jobcard.jc_status,

          eutDetails: parsedEUTDetails,
          tests: parsedJcTests,
          testDetails: parsedTestsDetails,

          reliabiltyTasks: parsedRelTasksDetails,
        });
      })
      .catch((error) => {
        console.error("Error fetching job card data:", error);
      });
  }, [id]);

  return (
    <div>
      {isPdfEnabled ? (
        <Button
          variant="contained"
          sx={{
            mx: 0.5,
            mb: 1,
            borderRadius: 3,
            bgcolor: "orange",
            color: "white",
          }}
          onClick={() => openJcPreview(jobCard)}
        >
          View / Download JC
        </Button>
      ) : (
        <Button
          variant="contained"
          sx={{
            mx: 0.5,
            mb: 1,
            borderRadius: 3,
            bgcolor: "orange",
            color: "white",
          }}
          onClick={() => downloadJcWord(jobCard)}
        >
          Download
        </Button>
      )}
    </div>
  );
};

export default JobCardComponent;
